import { LEGAL_DOCS_VERSION } from "../constants/legalDocuments";
import { LEGAL_PUBLIC_ENABLED } from "../constants/legalPaths";
import { normalizeRole } from "./roles";

export function hasCurrentTerms(profile) {
  if (!LEGAL_PUBLIC_ENABLED) return true;
  return String(profile?.legal_terms_version || "") === String(LEGAL_DOCS_VERSION);
}

export function hasCurrentConsentPd(profile) {
  if (!LEGAL_PUBLIC_ENABLED) return true;
  return (
    String(profile?.legal_consent_pd_version || "") === String(LEGAL_DOCS_VERSION)
  );
}

export function ownerNeedsLegal(profile) {
  if (!LEGAL_PUBLIC_ENABLED) return false;
  return !hasCurrentTerms(profile) || !hasCurrentConsentPd(profile);
}

export function clientNeedsConsent(card) {
  if (!LEGAL_PUBLIC_ENABLED) return false;
  if (!card?.consent_pd) return true;
  return String(card.consent_pd_version || "") !== String(LEGAL_DOCS_VERSION);
}

export function resolveLegalGateMode(role, profile) {
  if (!LEGAL_PUBLIC_ENABLED || !profile) return null;
  const r = normalizeRole(role);
  if (r === "owner" && ownerNeedsLegal(profile)) return "owner_blocking";
  return null;
}
